import { render, staticRenderFns } from "./MyAccount.vue?vue&type=template&id=6765a8e6&scoped=true"
import script from "./MyAccount.vue?vue&type=script&lang=js"
export * from "./MyAccount.vue?vue&type=script&lang=js"
function injectStyles (context) {
  
  var style0 = require("./MyAccount.vue?vue&type=style&index=0&id=6765a8e6&prod&lang=scss&scoped=true")
if (style0.__inject__) style0.__inject__(context)
var style1 = require("./MyAccount.vue?vue&type=style&index=1&id=6765a8e6&prod&lang=scss")
if (style1.__inject__) style1.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "6765a8e6",
  "44bf606e"
  
)

export default component.exports